module.exports = __webpack_public_path__ + "static/noise-5d66660597e1ceab84b4fd3cada3144c.png";